import { ImpContainer } from '@imprint-payments/imprint-ui';

import { useImpState } from '../../app/hooks';
import { getDomainFromMerchant } from '../../utils/environments';

export function LockupImage() {
  const { merchantData } = useImpState();

  return (
    <ImpContainer
      cursor="pointer"
      onClick={() => {
        window.location.href = getDomainFromMerchant(merchantData.productUUID);
      }}
    >
      <img src={merchantData.lockupImage} alt="lockup-img" />
    </ImpContainer>
  );
}
